import posthog from '@/lib/posthogWrapper';
import { loadScript } from './scriptLoader';
import * as Sentry from '@sentry/nextjs';
import { LandingError } from '@/types/errors';
import { TrackingParams } from '@/types';
export const fetchTIH = async (url: string) => {
	try {
		const landingResponse = await fetch(`/api/landing?url=${encodeURIComponent(url)}`);
		const data = await landingResponse.json();

		// Failure-only monitor: successes were 99.5% of ~750k events/month and carried no signal
		if (!landingResponse.ok) {
			posthog.capture('landing-api-response', {
				success: false,
				status: landingResponse.status,
				url,
			});
		}

		return data;
	} catch (err) {
		posthog.capture('landing-api-response', {
			success: false,
			url,
		});

		Sentry.withScope((scope) => {
			scope.setTag('api', 'landingAPI');
			scope.setLevel('error');
			Sentry.captureException(new LandingError(err as Error));
		});

		return {};
	}
};

export const isGtmLoaded = () => {
	if (typeof window === 'undefined') {
		return false;
	}

	window.dataLayer = window.dataLayer || [];
	const gtmStartedEvent = window.dataLayer.find((element) => element?.event === 'gtm.load');

	if (!gtmStartedEvent) {
		return false; // Not even the GTM inline config has executed
	} else if (!gtmStartedEvent['gtm.uniqueEventId']) {
		// GTM inline config has ran, but main GTM js is not loaded
		// (likely AdBlock, NoScript, URL blocking etc.)
		return false;
	}

	return true; // GTM is fully loaded and working
};

export const getTrackingParams = (): TrackingParams => {
	const currentParams = new URLSearchParams(window.location.search);

	return {
		fbclid: currentParams.get('fbclid') || '',
		gclid: currentParams.get('gclid') || '',
		wbraid: currentParams.get('wbraid') || '',
		gbraid: currentParams.get('gbraid') || '',
		rdt_cid: currentParams.get('rdt_cid') || '',
	};
};

export const loadGTM = (tag: string) => {
	// Skip GTM loading in CI environments
	if (process.env.CI || process.env.VERCEL_ENV === 'preview') {
		// eslint-disable-next-line no-console
		console.log('Skipping GTM load in CI/test environment');
		return;
	}

	window.dataLayer = window.dataLayer || [];

	// Push GTM initialization event
	window.dataLayer.push({
		'gtm.start': new Date().getTime(),
		event: 'gtm.js',
	});

	loadScript(
		{
			src: `https://www.googletagmanager.com/gtm.js?id=${tag}`,
			bundleId: tag,
			mustBeFirst: true,
			retry: true,
		},
		tag,
	);
};
